import ListingLayout from 'shared/components/listing-layout'
import { Table } from 'shared/components/table/table'
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface'
import { withErrorBoundary } from 'shared/hocs/with-error-boundary'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { usePagination } from 'shared/route-query/hooks/use-pagination'
import { ContactId } from '../../types/contact-interface'
import { useContactCommunities } from '../hooks/use-contact-communities'
import { ContactCommunitiesInterface } from '../types/contact-communities-interface'
import { getLoginCommunityUrl } from 'modules/commutinies/utils/get-community-url'

interface ContactCommunitiesProps {
  contactId: ContactId
}

const ContactCommunities = ({ contactId }: ContactCommunitiesProps) => {
  const { t } = useLocoTranslation()
  const { pagination, setPagination, limit, setLimit } = usePagination(true)
  const { contactCommunities } = useContactCommunities({ pagination, limit, contactId })

  const columns: ColumnDefinitionInterface<ContactCommunitiesInterface>[] = [
    {
      key: 'community',
      header: t('dashboard.contact_page.communities.headers.name'),
      onRender: ({ community }) => (
        <div className="truncate">
          <a
            target="_blank"
            rel="noreferrer"
            className="primary-link w-full"
            href={getLoginCommunityUrl(community)}
          >
            {community.name}
          </a>
        </div>
      ),
    },
  ]

  return (
    <ListingLayout
      data={contactCommunities}
      counter={false}
      title={
        <h2 className={'h-[42px] text-[17px] font-bold'}>
          {t('dashboard.communities.title_plural')}
        </h2>
      }
      type="compact"
    >
      <Table
        columns={columns}
        data={contactCommunities}
        limiter={{ limit, setLimit }}
        paginator={{ pagination, setPagination }}
        nestedId={'community'}
      />
    </ListingLayout>
  )
}

export default withErrorBoundary(ContactCommunities)
